import { render, staticRenderFns } from "./TermAndPolicy.vue?vue&type=template&id=760f3b1e"
import script from "./TermAndPolicy.vue?vue&type=script&lang=js"
export * from "./TermAndPolicy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports